<template>
  <div class="page-wrap">
    <div class="doing">
      <div class="doing-title" v-html="title"></div>
      <div class="doing-content" v-html="content"></div>
    </div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      content: '',
      doingContent: {
        '1': {
          title: '深入研究多因子投资，为量化交易“赋能”',
          content: `<p>
                    交易者在运用 T10 软件中的因子选股模型筛选出符合投资需求的个股名单后，如何把投资资金很好的分配到这些股票上，成为了接下来的一大难题。据我们观察，目前市面上的软件，对于想使用组合优化功能的交易者虽然提供了函数模型，但门槛非常高，既需要交易者有扎实的理论基础，同时又要兼备写代码和算式公式的能力，才真正能够使用该功能。所以怎样才能把这样一个有含金量的功能用相对简单、友好的方式呈现出来，降低使用者的门槛成为了我们研究的主要目标，就这样我们开启了组合赋权优化功能的研究之路。
                    </p>
                    <p>
                    因为组合赋权优化是量化投资的关键环节，注定了它的研究过程是个较为庞大而复杂的工程。为此，我们翻阅了非常多的书籍、各大证券公司发布的研报以及学术论文，充分汲取各方观点，来为我们的想法提供逻辑和理论上的支持。因为分配比例从理论上来说有无数种可能，所以如何组合、有没有最优比例等问题都等待着我们去探究，从而寻求一个最适合投资者的路径。在这个研究的过程中，最主要也是最困难的部分就是对于优化模型的选择。优化模型是靠目标函数和约束条件这两个方面决定的，不同的目标函数和不同的约束条件组合，会对应不同的优化模型的类型，所以我们研究的工作主要集中在了目标函数和约束条件上。
                    </p>
                    <p>
                    目标函数有很多不同的形式，需要考虑的因素众多，要兼顾策略的前后逻辑和实用性。首先，要跟我们之前设计的多因子充分结合，与之逻辑相通，才能保证前后的一致性；其次，要把准确性和效率相结合，计算用时决定了结果的精度，用时长最终结果的精度就高，精度高意味着准确性高，但是计算效率会影响交易者得到结果的等待时间，效率高等待时间短，而准确性又受到效率的影响，计算时间短会导致结果的准确性下降，所以它的难点在于要在等待时间和准确性二者之间取一个平衡；另外，我们还会跟开发的同事进行沟通交流，了解资源分配情况，以免因为运算量大造成运行速度慢的影响，最终确定要使用的目标函数。
                    </p>
                    <p>
                    目标函数选定之后，接下来就是约束条件的设置了，这一过程需要考虑的非常充分和全面，要尽量覆盖到交易者投资过程的各个方面，因此我们搜集了各量化基金构建组合时的约束变量，还会经常开分享会和讨论会来交换彼此的想法和见解，会中大家各抒己见，畅所欲言，实现思想上充分自由的碰撞。除了思考全面外，约束条件的设置还需兼顾交易者的实用性，如果光有理论支持，在实际使用过程中效果甚微，也不会纳入我们的选择范围。经过综合考量，最终我们确定使用个股权重、行业中性、风格中性、基准成分股权重这几个约束条件，后续，我们可能还会根据用户的使用反馈来丰富和增加条件。
                    </p>
                    <p>
                    模型确定好后，就要确认具体的实施路径了，即算法的选择。对于算法的选择也同样要满足上述要求，没有想象中那么容易，过程也不会一帆风顺。就比如我们在研究换手率这个约束条件的时候，就遇到了一些困难：一般的优化模型都是线性规划，而它是锥规划，所以涉及到的数学模型是比较复杂的，不知道其中函数的参数该如何去使用，所以就翻阅了官网的讲解和案例，虽然是纯英文的，但也一点点学习了下来；但是在应用后发现，它的运算时间长，对于我们的目标用户群体来说也不会起到很大的作用，所以最后果断舍弃了。算法确定后，研究的过程也就几乎接近了尾声，接下来就是测试的环节，我们会用 Python 编写模型来测试算法是否达到了我们的设计目标。如果达到了预期，就会上线供交易者们使用了。
                    </p>
                    <p>
                    最终，一个界面式操作的组合赋权优化功能就诞生了，它大大降低了使用者的专业性门槛，让交易者即使不懂复杂的编程和高深的数理统计知识，也可以轻松使用组合优化策略，为交易者提供了极大的便利。
                    </p>`
        },
        '2': {
          title: '用技术解决震荡行情',
          content: `<p>
                  行情总是在趋势和震荡中相互交替，针对震荡行情，我们在软件中添加了网格交易运行池功能。
                  </p>
                  <p>
                  震荡行情的特点是在某一个价格区间不断变换 ,反复震荡整盘，所以行情变化频繁，难以抓住交易时机等情况令交易者甚是苦恼。于是我们在想，有没有一种方法既能把交易者从需要随时盯盘的困扰中解放出来，又能让交易者在震荡行情下保证收益呢？因此我们运用了网格交易策略。
                  </p>
                  <p>
                  网格交易策略是通过自动执行低买高卖，从而获得价格震荡区间的波段收益的一种交易方法，而震荡行情又存在区间震荡、向上震荡和向下震荡三种情况，所以我们面临的第一个问题就是如何给出正确的趋势判断，并做出相适应的处理方式。针对这一难题，通过小组内多次研究讨论，最后决定用交易者自设点差来达到准确判断趋势的目的：交易者设置参数后，通过后台一系列复杂的算法机制，自动计算买入卖出点位并循环往复，所以不论是哪一种行情都可以轻松应对，这也是网格交易策略的精髓所在。
                  </p>
                  <p>
                  由于任务触发等情况较为复杂，处理起来比较混乱，又随即产生了一个新的问题：想要迅速准确的判断任务状态不是一件容易的事。于是我们又开启了新一轮的头脑风暴，每个人都在讨论中拿出了自己思考的解决方案，经过几次 “唇枪舌战”，大家发现现有的技术没有办法完全满足我们的想法和需求，于是我们就自主研发了“多态化处理技术”，通过把状态划分定义为多个种类，每种状态单独判断，以达到准确判断任务状态的目的。
                  </p>
                  <p>
                  随着对功能的深入思考，我们又想到了可能存在的一些其他的问题，比如：每个交易者可能会有很多个网格任务，那么在设置了大量的任务时，处理速度一定会变慢，如果因此导致触发不及时，错过了有利行情，会给交易者造成损失。所以针对这个问题，我们又创新了分布式存储技术，每一个都能够准确实时的判断到，能够快速判断触发；再比如如果交易者有几十个任务在同时进行，那么如何解决更新量大这个问题。为此我们研发了中央集更新技术和精准更新技术，方便多窗口调用，能够实现点对点的精准通知和消息变更，保证即使有大量任务同时进行的情况下，也可以避免出现更新不及时所造成的实际与客户所见不一致的情况，任务间互不干扰、保证准确性。
                  </p>
                  <p>
                  除了上述自研的技术外，我们还运用了其他很多先进的技术来解决可能遇到的问题，比如：为了让功能具备高的扩展性，我们采用了灵活的委托方式，并通过多线程技术减少主处理时间，采用一应一答的方式触发，即外部一旦发生变化我们也会立刻做出变化，以此来保证准确性和及时性；运用分类别储存，能够轻松实现自动备份，在下次账号登录时快速定位到退出时的状态；运用列表虚拟化来按需更新，减少对资源的占用，使软件的使用更顺畅等。
                  </p>
                  <p>
                  网格交易运行池功能为交易者提供了极大的便捷性，可以让交易者被动做到高抛低吸，克服人性弱点，降低交易者对行情波动方向的误判损失，为交易者提供自动、快速、准确的交易体验。
                  </p>`
        },
        '3': {
          title: '运用云计算和量化交易技术助力智能投顾服务',
          content: `<p>
                  由软件开发团队程序化开发小组开发的 ICS 智能投顾系统，是期货公司为交易者提供投顾服务的平台。 系统由管理端和用户使用端构成。管理端提供便捷、智能的策略研发、策略管理环境，助力期货公司把量化投研成果转化为产品服务。用户使用端以丰富的图表，多维度向用户展示策略的绩效情况，用户可根据自己的交易习惯、风险偏好，选择策略进行订阅。
                  </p>
                  <p>
                  从上面的系统构成中不难看出，我们的开发工作会面临两大难题：一是数据处理量大 ，二是保证系统的及时性和准确性，所以在需求讨论会和技术交流会上，通过充分的探讨和不断完善，最后逐一攻克了难题 ——
                  </p>
                  <p>
                  首先，系统的数据处理量庞大。一是策略的研发、管理、展示和订阅是系统的主要服务内容，而策略即指量化模型，其中涉及大量的算法；二是要接收实时行情数据，执行策略，触发交易信号；三是回测报告需要大量历史数据，这些数据就在云端管理。所以我们运用了云计算，来完成大量的数据处理工作，而不用担心速度和准确性。
                  </p>
                  <p>
                  其次，智能投顾服务系统的运行是错综复杂的，众多的交易策略、订阅信息、交易连接的管理都需要在云端储存，这其中信息量的庞大可想而知，那么如何让系统保证行情及时触发、策略及时发出交易信号、信号及时转换成交易指令发送到后台，成为了我们研发工作的重中之重。所以在开发系统前期，我们做了大量准备工作，针对数据库的选择、数据的压缩之类的问题，提出了多种方案，并把这些方案逐一进行比对，经过对各个方面利弊的权衡和讨论，我们最终决定采用统一管理机制 ——分布式系统。分布式系统的优势有很多，首先可以保证每个运行单元都能够作为一个独立服务运行在分布式系统中，彼此间没有任何影响；其次，可扩展性强，即使用户量大幅度增加，也可以通过添加电脑设备的方式来提高更大的并发量，非常方便快捷。
                  </p>
                  <p>
                  之后的开发过程实际都非常顺利，在分布式系统中，我们应用了多项软件中的主流技术，其中包括消息队列中间件，它是分布式系统的重要组件，无论是消息的分发还是运行服务的管理等都依靠消息队列来完成；因为指令消息的数量众多，我们唯一遇到的难题可能就是如何保证运行服务的唯一性，所以我们使用了分布式应用程序协调服务（ ZooKeeper ），来保证任务和指令不会重复运行。另外，因为策略回测需要大量的历史数据，为了避免出现读取速度慢的情况，我们决定把数据做压缩处理，这时我们想到了之前自主研发的压缩算法，可以把历史行情数据在储存时压缩到原来的 1/10 左右，所以我们就充分发挥了“拿来主义”哈哈。
                  </p>
                  <p>
                  除了上述问题外，由于系统中所涉及的数据量非常庞大，我们实际还面临着一个难题，就是数据的安全和维护。因此，我们采用了 Radis 等分布式数据库和日志管理系统（ ELK ），这样在充分保证了数据安全性的同时，又可以在出现问题时，快速定位到问题，也能够提供日常监控的功能和信息，便于运维人员的常规维护。
                  </p>
                  <p>
                  智能投顾服务系统的开发，犹如在期货公司和个人交易者之间架起了一座桥梁，简化了用户的交易形式，希望以此来推动期货市场和量化交易的发展，引领更多投资者使用更科学的交易方式在期货市场中打拼。
                  </p>`
        }
      },
    };
  },
  watch: {
    '$route.params': {
      handler(val) {
        let {id} = val;
        this.title = this.doingContent[id]?.title || '',
        this.content = this.doingContent[id]?.content || '';
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.page-wrap {
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.doing {
  padding: 0 0.54rem;
}
.doing-title {
  margin: 1.86rem 0 1rem 0;
  font-weight: bold;
  font-size: 0.68rem;
  text-align: center;
}
.doing-content {
  font-size: 0.63rem;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 1rem;
}
.doing-content >>> p {
  text-indent: 2em;
  line-height: 2;
  margin: 0;
}
</style>